<template>
  <div>
    <file-upload-local
      v-model="fileUrl"
      :accept="accept"
      :tips="tips"
      :list-type="listType"
      :multiple="multiple"
      :limit="limit"
    />
  </div>
</template>

<script>

import FileUploadLocal from './local'

export default {
  name: 'FileUpload',
  components: { FileUploadLocal },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    value: [String, Array],
    accept: {
      type: String,
      default: '*'
    },
    // eslint-disable-next-line vue/require-default-prop
    tips: String,
    listType: {
      type: String,
      default: 'picture'
    },
    multiple: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      fileUrl: this.multiple ? [] : ''
    }
  },

  watch: {
    // 检测查询变化
    value: {
      handler() {
        this.fillValue()
      }
    },

    // 检测查询变化
    fileUrl: {
      handler() {
        this.$emit('input', this.fileUrl)
      }
    }
  },
  mounted() {

  },

  created() {
    this.fillValue()
  },

  methods: {

    fillValue() {
      if (this.multiple) {
        this.fileUrl = Array.isArray(this.value) ? [...this.value] : []
      } else {
        this.fileUrl = this.value || ''
      }
    }

  }
}
</script>
